import axios from 'axios';



const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';



const api = axios.create({

  baseURL: API_BASE_URL,

  timeout: 10000,

  headers: {

    'Content-Type': 'application/json',

    'Referrer-Policy': 'no-referrer-when-downgrade',

  },

  withCredentials: true,

});



api.interceptors.request.use(

  (config) => {

    const token = localStorage.getItem('access_token');

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



api.interceptors.response.use(

  (response) => response,

  (error) => {

    if (error.response?.status === 401) {

      localStorage.removeItem('access_token');

      localStorage.removeItem('username');

      window.location.href = '/login';

    }

    return Promise.reject(error);

  }

);



export const authAPI = {

  login: (username, password) => {

    const formData = new URLSearchParams();

    formData.append('username', username);

    formData.append('password', password);

    return api.post('/auth/login', formData, {

      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

    });

  },



  activationLogin: (activationCode) => {

    return api.post('/auth/activation-login', { activation_code: activationCode });

  },



  getMe: () => {

    return api.get('/auth/me');

  },

};



export const adminAPI = {

  createActivationCode: (username, maxUses = 1, expireDays = 30) => {

    return api.post('/admin/activation-codes', null, {

      params: { username, max_uses: maxUses, expire_days: expireDays },

    });

  },



  listActivationCodes: () => {

    return api.get('/admin/activation-codes');

  },



  revokeActivationCode: (codeId) => {

    return api.delete(`/admin/activation-codes/${codeId}`);

  },



  createUser: (username, role = 'USER') => {

    return api.post('/admin/users', null, {

      params: { username, role },

    });

  },



  listUsers: () => {

    return api.get('/admin/users');

  },



  listRoles: () => {

    return api.get('/admin/roles');

  },

};



export const menuAPI = {

  listMenus: () => api.get('/menu/menus'),

  listMenusFlat: () => api.get('/menu/menus/flat'),

  createMenu: (data) => api.post('/menu/menus', data),

  updateMenu: (id, data) => api.put(`/menu/menus/${id}`, data),

  deleteMenu: (id) => api.delete(`/menu/menus/${id}`),

  assignMenuToUser: (userId, menuId) => api.post(`/menu/users/${userId}/menus`, { menu_id: menuId }),

  removeMenuFromUser: (userId, menuId) => api.delete(`/menu/users/${userId}/menus/${menuId}`),

  getUserMenus: (userId) => api.get(`/menu/users/${userId}/menus`),

  getAvailableMenus: (userId) => api.get(`/menu/users/${userId}/available-menus`),

  readMenuFile: (menuId) => api.get(`/menu/file/${menuId}`),

};



export default api;

